<template>
  <!--srccomponentsgui_chartgui_chartvuehtmlStart-->

  <div id="defaultId1" class="u34e96">
    <div
      id="cdc31b"
      class="u01533"
      :class="TiptagsArrList.length > 0 ? ' u01533height60' : 'u01533height80'"
    >
      <div id="cd72ff" class="u7eb26">
        <div id="g44c09" @click="isVip = !isVip" class="u64b72">
          <img
            id="g61a71"
            class="u81734"
            src="../../assets/images/chart2.png"
            alt=""
          />
        </div>
        <div id="c8feef" class="uee8c0">
          Hi I'm Zaba – Your research assistant
        </div>

        <div id="gbbfc3" @click="hide" class="uad917">
          <i class="el-icon-close iconDelete"></i>
          <svg
            id="c1e481"
            @click="isShowChat = false"
            class="icon uVMhwhN"
            t="1709707145644"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="6200"
            width="16"
            height="16"
          >
            <path
              id="c171b2"
              d="M0 0h1024v1024H0z"
              fill="#FF0033"
              fill-opacity="0"
              p-id="6201"
            ></path>
            <path
              id="c59831"
              d="M240.448 168l2.346667 2.154667 289.92 289.941333 279.253333-279.253333a42.666667 42.666667 0 0 1 62.506667 58.026666l-2.133334 2.346667-279.296 279.210667 279.274667 279.253333a42.666667 42.666667 0 0 1-58.005333 62.528l-2.346667-2.176-279.253333-279.253333-289.92 289.962666a42.666667 42.666667 0 0 1-62.506667-58.005333l2.154667-2.346667 289.941333-289.962666-289.92-289.92a42.666667 42.666667 0 0 1 57.984-62.506667z"
              fill="#111111"
              p-id="6202"
            ></path>
          </svg>
        </div>
      </div>
      <div id="c8e57a" class="u98bef">
        <div id="c630d0" class="u213f4" ref="messages">
          <div v-show="chartList.length > 0 && !isShowSideBar" class="floatBox">
            <el-popover
              placement="top"
              trigger="hover"
              popper-class="table_popover zaba_popover"
              content="Open sidebar"
            >
              <div class="iconBox" slot="reference">
                <i
                  class="floatIcon iconfont icon-cebianlan"
                  @click="isShowSideBar = true"
                ></i>
              </div>
            </el-popover>
            <el-popover
              placement="top"
              trigger="hover"
              popper-class="table_popover zaba_popover"
              content="Open a new conversation"
            >
              <div class="iconBox" slot="reference">
                <i
                  class="floatIcon iconfont icon-xinduihua-01"
                  @click="(chartList = []), (TiptagsArrList = [])"
                ></i>
              </div>
            </el-popover>
          </div>
          <div
            id="cdec0b"
            class="margin-bottom30"
            v-for="(item, index) in chartList"
            :key="index"
          >
            <div id="cc2536" class="ue7063" v-if="!item.isMy">
              <div id="c6711b" class="u1f654">
                <img
                  id="ca532a"
                  v-if="loadig && index == chartList.length - 1"
                  class="u5c5dc"
                  src="../../assets/images/Aigif.gif"
                  alt=""
                />
                <img
                  id="ca532a"
                  v-else
                  class="u5c5dc"
                  src="../../assets/images/chart2.png"
                  alt=""
                />
              </div>
              <div id="c23250" class="uda7fd">
                <div
                  id="c5f6f8"
                  class="ub575f"
                  v-html="$marked(item.content)"
                ></div>
              </div>
            </div>
            <div id="c24975" class="ue7063 u042ca" v-if="item.isMy">
              <div id="c58973" class="u1f654">
                <img
                  id="cdff08"
                  :src="imageUrl"
                  v-if="imageUrl"
                  class="u5c5dc"
                />
                <div v-else class="avatar avatartex avatarnologin">
                  <div class="avatar_content">
                    {{ userInfo?.userInfo?.firstName.substring(0, 1) }}
                  </div>
                </div>
              </div>
              <div id="c37c2c" class="uda7fd uffe54">
                <div
                  id="c2bd98"
                  class="ub575f uCTCvwp"
                  v-html="item.content"
                ></div>
              </div>
            </div>
          </div>
          <div id="c9674d" v-loading="loadig" class="u55a82"></div>
        </div>
      </div>
    </div>
    <div id="cf58eb" class="uddc76">
      <div :class="CreditAnalyst ? '' : 'uddc76F5'">
        <div v-if="!CreditAnalyst && !loadig">
          <div class="uddc76ContentTwo">
            <div
              class="messAgeClose messAgeCloseTip"
              v-for="(item, index) in TiptagsArrList"
              :key="index"
              @click="tagsArrTip(item, index)"
            >
              <span class="messAgeClose-text">
                <svg
                  t="1742890623465"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="6444"
                >
                  <path
                    d="M820.87 100.46c73.4-0.01 134.16 57.03 138.79 130.29l0.26 8.76V414.6c0.1 19.03-14.61 34.86-33.6 36.15-18.99 1.3-35.7-12.39-38.19-31.26l-0.31-4.89V239.51c0-34.32-25.96-63.08-60.1-66.59l-6.85-0.36H202.91c-34.32 0-63.08 25.96-66.59 60.1l-0.36 6.85v411.98c0 34.31 25.96 63.07 60.1 66.59l6.85 0.36h41.19c18.03-0.01 33.29 13.29 35.74 31.16l0.31 4.89v82.39l148.31-111.23a36.067 36.067 0 0 1 15.86-6.69l5.77-0.52h144.19c19.03-0.1 34.86 14.61 36.16 33.6 1.29 18.99-12.4 35.71-31.27 38.19l-4.89 0.31H462.04L306.93 906.92c-25.22 18.91-60.64 15.81-82.19-7.21l-4.33-5.15a61.813 61.813 0 0 1-11.85-29.09l-0.52-7.98-0.05-66.95h-5.1c-73.4 0.01-134.17-57.03-138.79-130.29l-0.26-8.75V239.51c-0.01-73.4 57.03-134.17 130.29-138.79l8.76-0.26h617.97z m-20.6 392c18.05-0.01 33.32 13.32 35.74 31.21l0.3 4.89v85.59h87.55c19.03-0.1 34.86 14.61 36.15 33.6 1.3 18.99-12.39 35.71-31.26 38.19l-4.89 0.31h-87.55v85.59c0.1 19.03-14.61 34.86-33.59 36.15-18.99 1.3-35.71-12.39-38.19-31.26l-0.31-4.89v-85.59h-87.54c-19.03 0.1-34.86-14.61-36.16-33.6-1.29-18.99 12.4-35.71 31.26-38.19l4.9-0.31h87.54v-85.59a36.052 36.052 0 0 1 36.05-36.05v-0.05z m-261.6-52.12c19.04-0.13 34.89 14.58 36.21 33.57 1.31 18.99-12.39 35.73-31.26 38.21l-4.89 0.31H291.55c-19.03 0.1-34.86-14.61-36.16-33.6-1.29-18.99 12.4-35.7 31.26-38.19l4.84-0.31h247.19zM415.08 297.23c19.04-0.13 34.89 14.58 36.21 33.57 1.31 19-12.39 35.73-31.27 38.21l-4.89 0.31H291.54c-18.88-0.1-34.49-14.76-35.77-33.59-1.29-18.84 12.18-35.48 30.88-38.14l4.9-0.36h123.59-0.05z m0 0"
                    p-id="6445"
                    fill="#1A2332"
                  ></path>
                </svg>
                {{ item }}
              </span>
            </div>
          </div>
        </div>
        <div class="uddc76Content">
          <div id="gbc645" class="u7c8c3">
            <div id="g20209" class="ub8303">
              <el-input
                id="c5d59f"
                v-loading="loadig"
                @keydown.native="handleKeydown($event)"
                v-model="str"
                type="textarea"
                :rows="chartList.length > 0 ? '1' : '4'"
                :placeholder="$t('AiZaba.whatareyousearchingfor')"
              />
            </div>

            <div id="gb879d" class="u49be8">
              <button
                id="c09127"
                @click="sendMsg()"
                :class="str ? 'ucLkAbZ ucLkAbZbluc' : 'ucLkAbZ'"
                type="primary"
                :disabled="!str"
              >
                <svg
                  t="1742882606489"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="6194"
                  width="20"
                  height="20"
                >
                  <path
                    d="M0 0h1024v1024H0z"
                    fill="#ffffff"
                    opacity=".01"
                    p-id="6195"
                  ></path>
                  <path
                    d="M487.867733 146.5344a34.133333 34.133333 0 0 1 48.264534 0l307.2 307.2a34.133333 34.133333 0 0 1-48.264534 48.264533L546.133333 253.064533V853.333333a34.133333 34.133333 0 1 1-68.266666 0V253.064533l-248.9344 248.9344a34.133333 34.133333 0 0 1-48.264534-48.264533l307.2-307.2z"
                    fill="#ffffff"
                    p-id="6196"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div v-if="CreditAnalyst && chartList.length == 0">
          <div class="uddc76ContentTwo">
            <div
              class="uddc76ContentTwo-box"
              :class="
                tagsArrListIndex == index ? 'uddc76ContentTwo-box-border' : ''
              "
              v-for="(item, index) in tagsArrList"
              :key="index"
              @click="tagsArrHover(item, index)"
            >
              <p>{{ item.head }}</p>
              <div class="uddc76ContentTwo-boxtext">
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="!CreditAnalyst || chartList.length > 0">
          <div class="uddc76ContentThree">
            <div
              class="uddc76ContentThree-box"
              :class="
                tagsArrListIndex == index ? 'uddc76ContentTwo-box-border' : ''
              "
              v-for="(item, index) in tagsArrList"
              :key="index"
              @click="tagsArrHover(item, index)"
            >
              <span>{{ item.head }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chartSideBar" v-show="isShowSideBar">
      <div class="SideBarTop margin-bottom20">
        <div class="SideBarToptxt">Historic Records</div>
        <el-popover
          placement="top"
          trigger="hover"
          popper-class="table_popover zaba_popover"
          content="Close sidebar"
        >
          <div class="iconBox" slot="reference">
            <i
              class="floatIcon iconfont icon-cebianlan"
              @click="isShowSideBar = false"
            ></i>
          </div>
        </el-popover>
      </div>
      <div class="SideBarClose">
        <span
          class="SideBarClose-text"
          @click="
            (chartList = []), (TiptagsArrList = []), (isShowSideBar = false)
          "
        >
          <i class="floatIcon iconfont icon-xinduihua-01"></i>
          Open a new chat
        </span>
      </div>
      <div class=""></div>
    </div>
  </div>
  <!--srccomponentsgui_chartgui_chartvuehtmlEnd-->
</template>
<script>
import { getQuestions } from "@/api/companyApi";
import gui_scroll_x from "../gui_scroll_x/gui_scroll_x.vue";
//importEnd
export default {
  name: "",
  props: {
    // srccomponentsgui_chartgui_chartvuePropsStart

    // 高度
    height: {
      type: Number,
      default: 992,
    },
    // 宽度
    width: {
      type: Number,
      default: 620,
    },
    // srccomponentsgui_chartgui_chartvuePropsEnd
  },
  mounted() {
    // defaultLoad
    // srccomponentsgui_chartgui_chartvueMountedStart
    // srccomponentsgui_chartgui_chartvueMountedEnd
  },
  components: {
    // gui_scroll_x start
    gui_scroll_x,
    // gui_scroll_x end
  },
  data() {
    return {
      // insertData
      // srccomponentsgui_chartgui_chartvueDataStart

      // 是否vip
      isVip: false,
      loadig: false,
      CreditAnalyst: true,
      // chartList
      chartList: [],
      AiType: null,
      // tags
      tags: [
        {
          name: this.$t("AiZaba.CreditAnalyst"),
        },
        {
          name: this.$t("AiZaba.LegalAdvisor"),
        },
        {
          name: this.$t("AiZaba.BizConsultant"),
        },
        {
          name: this.$t("AiZaba.EconomicAnalyst"),
        },
      ],
      tagsArrList: [
        {
          text: this.$t("AiZaba.Assesses"),
          head: this.$t("AiZaba.CreditAnalyst"),
          type: 1,
        },
        {
          text: this.$t("AiZaba.Provides"),
          head: this.$t("AiZaba.LegalAdvisor"),
          type: 2,
        },
        {
          text: this.$t("AiZaba.Optimizes"),
          head: this.$t("AiZaba.BizConsultant"),
          type: 3,
        },
        {
          text: this.$t("AiZaba.Analyzes"),
          head: this.$t("AiZaba.EconomicAnalyst"),
          type: 4,
        },
      ],
      TiptagsArrList: [],
      //
      fileName: "",
      tagsArrListIndex: 5,
      fileNameObj: {
        file_name: "one",
      },
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      audioUploadPercent: "",
      audioFlag: "",
      str: "",
      eventSource: null,
      token: localStorage.getItem("token"),
      isShowTool: false,
      isShowSideBar: false,
      eventStreamData: "",
      imageUrl:
        JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
          ? ""
          : "https://www.csibizsearch.com/csi/usercenter/download/resource?resource=" +
            JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg,
      // srccomponentsgui_chartgui_chartvueDataEnd
    };
  },
  created() {
    if (this.token) {
      this.imageUrl =
        JSON.parse(localStorage.getItem("userInfoImg")) == undefined
          ? this.imageUrl
          : JSON.parse(localStorage.getItem("userInfoImg"));
    }
  },
  methods: {
    tagsArrTip(item, index) {
      this.str = item;
      this.sendMsg();
    },
    tagsArrHover(item, index) {
      this.AiType = item.type;
      if (index != this.tagsArrListIndex) {
        this.tagsArrListIndex = index;
      } else {
        this.tagsArrListIndex = undefined;
      }
    },
    // insertMethod
    // srccomponentsgui_chartgui_chartvueMethodStart
    // 点击隐藏
    hide() {
      this.CreditAnalyst = true;
      this.$emit("hide", false);
    }, //
    getFilename(file) {
      this.fileNameObj.file_name = file.name;
    }, //
    uploadaudioProcess(event, file, fileList) {
      this.audioFlag = true;
      this.audioUploadPercent = file.percentage.toFixed(0) * 1;
    }, //
    handleaudioSuccess(res, file, x) {
      this.audioFlag = false;
      this.audioUploadPercent = 0;
      if (res.data.info) {
        // 首次上传找不到filename
        x.note = res.data.info.url;
      }
    }, //
    beforeAvatarUpload(file) {
      const isJPG = /image.*/.test(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error(
          "Uploading avatar images can only be in JPG format!",
        );
      }
      if (!isLt2M) {
        this.$message.error(
          "Uploading avatar images can only be in JPG format!",
        );
      }
      this.fileNameObj.file_name = file.name;
      return isJPG && isLt2M;
    }, // sendMsg
    handleKeydown(event) {
      if (
        event.key == "Enter" ||
        event.code == "Enter" ||
        event.keyCode == 13
      ) {
        event.preventDefault();
        this.sendMsg();
      }
    },

    sendMsg() {
      this.CreditAnalyst = false;

      if (!this.str) {
        return;
      }

      this.chartList.push({
        name: "我",
        isMy: true,
        content: this.str,
      });
      const token = localStorage.getItem("token");
      getQuestions({
        country: "CN",
        question: this.str,
        chatId: token,
        uid: this.userInfo?.userInfo?.id,
        name: 123,
        type: this.AiType,
      }).then((res) => {
        if (res.code == 200) {
          this.TiptagsArrList = res.data;
        }
      });
      this.startEventStream(token);

      this.chartList.push({
        name: "baza",
        isMy: false,
        content: "",
      });
      this.str = "";
    },
    startEventStream(token) {
      this.loadig = true;
      // 创建 EventSource 实例，连接到服务器的事件流

      // https://www.csibizsearch.com/csi
      let api =
        process.env.NODE_ENV == "development"
          ? "/devapi"
          : "https://csibizsearch.com/csi"; //new-测试
      this.eventSource = new EventSource(
        api +
          "/ai/question?country=CN&question=" +
          this.str +
          "&Authorization=" +
          token +
          "&chatId=" +
          token +
          "&uid=" +
          this.userInfo?.userInfo?.id +
          "&name=123",
      );

      // 监听消息事件
      this.eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.content != null) {
          const messagesContainer = this.$refs.messages;

          setTimeout(() => {
            this.chartList[this.chartList.length - 1].content += data.content;
            this.$nextTick(() => {
              messagesContainer.scrollTop = messagesContainer.scrollHeight;
            });
          }, 1000);
        }
      };

      // 监听错误事件
      this.eventSource.onerror = (error) => {
        this.loadig = false; // 停止加载状态
        this.eventSource.close();
      };

      // 监听连接打开事件
      this.eventSource.onopen = () => {};
    },
    stopEventStream() {
      if (this.eventSource) {
        this.loading = false; // 停止加载状态
        this.eventSource.close(); // 关闭 EventSource 连接
      }
    },
  },

  computed: {},
};
</script>
<style scoped>
.u34e96 {
  width: 100%;
  height: 100%;
  box-shadow: -10px 10px 14px 0px rgba(0, 0, 0, 0.12);
  background-color: #f5f5f5;
}

.u01533 {
  display: flex;
  width: 100%;
  flex-direction: column;
  position: static;
  overflow-x: hidden;
  overflow-y: hidden;
}
.u01533height60 {
  height: 64%;
}
.u01533height80 {
  height: 80%;
}
.u7eb26 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 88px;
  padding: 20px 30px;
  background-color: rgba(18, 144, 201, 1);
}
.new-layout-con-trade .u7eb26,
.trade_layout .u7eb26 {
  background-color: rgb(0, 158, 167);
}
.html-new-page:has(.leads) .u7eb26 {
  background: #8e86dd;
}
.u64b72 {
  margin-right: 10px;
}

.uee8c0 {
  flex: auto;
  font-size: 20px;
  color: #ffffff;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.uad917 {
  height: 20px;
}

.uVMhwhN {
  display: none;
}

.u98bef {
  display: flex;
  height: 0;
  flex-direction: column;
  flex: auto;
  overflow-y: auto;
}

.u213f4 {
  flex: auto;
  overflow-x: auto;
  padding: 20px;
}
.floatBox {
  display: flex;
  position: absolute;
  width: 100px;
  height: 48px;
  border-radius: 24px;
  top: 108px;
  left: 20px;
  z-index: 9999999;
  background-color: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.16);
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.iconBox {
  width: 24px;
  height: 24px;
}
.floatIcon {
  font-size: 24px;
  color: #1290c9;
}

.u55a82 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.42857142857142855rem;
  font-size: 1rem;
  color: #a2a9b0;
  line-height: 1.1428571428571428rem;
  text-align: center;
  font-style: normal;
}

.ue7063 {
  display: flex;
}

.u1f654 {
  width: 40px;
  height: 40px;
  overflow-x: hidden;
  overflow-y: hidden;
  border-radius: 20px;
  margin-right: 10px;
  background: #f5f5f5;
}

.u5c5dc {
  width: 100%;
  height: 100%;
}

.uda7fd {
  width: 0%;
  flex: auto;
  box-sizing: content-box;
  position: relative;
}

.ub575f {
  width: max-content;
  color: #1a2332;
  font-size: 16px;
  padding: 10px 20px;
  line-height: 30px;
  max-width: 100%;
  word-wrap: break-word;
}

.u042ca {
  display: flex;
  flex-direction: row-reverse;
}

.uffe54 {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  flex-direction: column;
  margin-right: 10px;
}

.uCTCvwp {
  color: rgba(26, 35, 50, 1);
  background-color: #eeeeee;
  border-radius: 16px;
  border-top-right-radius: 0px;
}

.index_chart_gpt {
  position: relative;
}

.uddc76 {
  position: absolute;
  bottom: 0px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: 16px;
  width: 100%;
}
.uddc76F5 {
  background: #ffffff;
}

.u7c8c3 {
  position: relative;
}

.ub8303 {
  flex: auto;
}
.ub8303 /deep/ .el-textarea__inner {
  font-size: 18px;
  border: none !important;
  color: #1a2332;
  padding: 0px;
}

.u49be8 {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  bottom: 0px;
  right: -6px;
}

.ucLkAbZ {
  width: 40px;
  height: 40px;
  overflow-x: hidden;
  overflow-y: hidden;
  border-radius: 50%;
  background: #d5dee8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.u635e3 {
  width: 100%;
}

.u47c8b {
  text-align: center;
}

.mark_box i {
  color: rgb(254, 3, 3);
}

.iconDelete {
  font-size: 20px;
  color: #fff;
}

.avatar_content {
  font-size: 20px;
  cursor: pointer;
}

.avatarnologin {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: block;
  background: #f5f5f5;
  line-height: 40px;
  text-align: center;
  color: #a2a9b0;
  overflow: hidden;
}

.uddc76Content {
  margin: 0px 30px;
  padding: 20px;
  padding-bottom: 14px;
  background: #fff;
  border: 1px solid #999999;
  border-radius: 16px;
}

.uddc76ContentTwo {
  margin: 0px 30px;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.uddc76ContentThree {
  margin: 0px 30px;
  margin-top: 10px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 6px;
}

.uddc76ContentTwo-box {
  width: 260px;
  padding: 20px;
  border-radius: 16px;
  border: 1px solid #999999;
  margin-bottom: 20px;
  cursor: pointer;
  background-color: #fff;
}
.uddc76ContentThree-box {
  height: 36px;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  border: 1px solid #999999;
  margin-bottom: 20px;
  cursor: pointer;
  background-color: #fff;
  flex-grow: 1;
}
.uddc76ContentThree-box span {
  font-size: 16px;
  line-height: 26px;
}
.uddc76ContentTwo-box p {
  font-size: 20px;
  line-height: 28px;
  text-align: left;
  margin-bottom: 10px;
  font-family: "Arial Bold";
}

.uddc76ContentTwo-boxtext {
  color: #1a2332;
  font-size: 16px;
  text-align: left;
  line-height: 1.5;
  overflow-wrap: break-word;
}

.uddc76ContentTwo-box-border p,
.uddc76ContentTwo-box-border span,
.uddc76ContentTwo-box-border .uddc76ContentTwo-boxtext {
  color: #1290c9;
  border-color: #1290c9;
}
.uddc76ContentTwo-box-border {
  border-color: #1290c9;
}
/deep/ .el-loading-mask {
  background-color: transparent !important;
}

.ucLkAbZbluc {
  background-color: #1290c9;
}

.messAgeClose {
  width: 56%;
  cursor: pointer;
  height: 48px;
  background: #deefff;
  border-radius: 24px;
  display: flex;
  align-items: center;
  padding-left: 20px;
}
.messAgeCloseTip {
  color: #1a2332;
  width: 90%;
  margin: 0;
  margin-bottom: 10px;
  background: #eeeeee;
}
.messAgeCloseTip .messAgeClose-text {
  color: #1a2332;
}
.messAgeClose-text {
  font-size: 18px;
  color: #1290c9;
  display: flex;
  align-items: center;
}

.messAgeClose-text .icon {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}
@media (max-width: 1920px) {
  .u7eb26 {
    height: 66px;
    padding: 15px 24px;
  }
  .uee8c0 {
    font-size: 16px;
    line-height: 16px;
  }
  .uad917 {
    height: 16px;
  }
  .iconDelete {
    font-size: 16px;
  }
  .uddc76Content {
    padding: 15px;
    padding-bottom: 12px;
    border-radius: 12px;
  }
  .uddc76ContentTwo-box {
    padding: 15px;
    border-radius: 12px;
  }
  .uddc76ContentThree-box {
    height: 32px;
  }
  .uddc76ContentThree-box span {
    font-size: 14px;
    line-height: 20px;
  }
  .uddc76ContentTwo-box p {
    font-size: 16px;
    line-height: 20px;
  }

  .uddc76ContentTwo-boxtext {
    font-size: 14px;
  }
  .u213f4 {
    padding: 15px;
  }
  .u49be8 {
    right: -3px;
    bottom: -2px;
  }
  .ub8303 /deep/ .el-textarea__inner {
    font-size: 14px;
  }
  .ucLkAbZ {
    width: 30px;
    height: 30px;
  }
  .messAgeClose {
    height: 36px;
    border-radius: 18px;
    padding-left: 16px;
  }
  .messAgeClose-text {
    font-size: 16px;
  }
  .messAgeClose-text .icon {
    width: 16px;
    height: 16px;
  }
  .floatBox {
    top: 81px;
    left: 15px;
  }
}
@media (max-width: 1439px) {
  .u7eb26 {
    height: 58px;
    padding: 13px 20px;
  }
  .uee8c0 {
    font-size: 14px;
    line-height: 14px;
  }
  .uad917 {
    height: 14px;
  }
  .iconDelete {
    font-size: 14px;
  }
  .uddc76Content {
    padding: 12px;
    padding-bottom: 10px;
    border-radius: 10px;
  }
  .uddc76ContentTwo-box {
    padding: 12px;
    border-radius: 10px;
  }
  .u213f4 {
    padding: 12px;
  }
  .u49be8 {
    right: -2px;
    bottom: -2px;
  }
  .ucLkAbZ {
    width: 28px;
    height: 28px;
  }
}
</style>
